import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  type: 'Type',
  manualCardEntry: 'Manual card entry',
  copyLink: 'Copied link',
  smsLink: 'SMS link',
  emailLink: 'Email link',
})
